<div [formGroup]="form" class="financial-info-container">
  <div class="label-parent">
    <span class="label">
      {{ "financial-information.title_breakdown" | translate }}
    </span>

    <tui-icon
      *ngIf="!isEditMode"
      icon="tuiIconEdit2"
      size="m"
      class="icon_edit_assigned_hour"
      (click)="enterEditMode()"
    ></tui-icon>

    <div *ngIf="isEditMode" class="btn-group">
      <button type="button" class="cancel-btn" (click)="cancelEdit()">
        {{ "financial-information.button_cancel" | translate }}
      </button>
      <button
        type="button"
        class="btn-save"
        [disabled]="saving || form.invalid"
        (click)="saveChanges()"
      >
        <ng-container *ngIf="!saving; else loading">
          {{ "financial-information.button_save" | translate }}
        </ng-container>
        <ng-template #loading>
          <tui-loader size="s"></tui-loader>
        </ng-template>
      </button>
    </div>
  </div>

  <div class="financial-info-container-child mt-2"></div>

  <ng-container formArrayName="products" class="product-container">
    <ng-container
      *ngFor="let ctrl of productsFA.controls; let i = index"
      [formGroupName]="i"
    >
      <div class="frame-group product-row">
        <div class="servicios-parent">
          <ng-container *ngIf="getProductIcon(ctrl.value.label) as icon">
            <img
              [src]="icon"
              [alt]="ctrl.value.label"
              class="product-icon"
              loading="lazy"
            />
          </ng-container>
          <span class="product-label">
            {{ getProductNameTranslatedByProductName(ctrl.value.label) }}
          </span>
        </div>

        <div class="license-plate1">
          <span *ngIf="!isEditMode">
            {{ ctrl.value.amount | number : "1.2-2" }} {{ currency }}
          </span>
          <input
            *ngIf="isEditMode"
            formControlName="amount"
            type="number"
            max="9999999"
            maxlength="7"
            (keydown)="limitLengthOnKeydown($event, ctrl.get('amount'))"
            inputmode="decimal"
            min="0"
            step="0.01"
            class="price-input"
          />
        </div>
      </div>

      <div
        class="error-msg"
        *ngIf="
          isEditMode &&
          ctrl.get('amount')?.invalid &&
          (ctrl.get('amount')?.dirty || ctrl.get('amount')?.touched)
        "
      >
        <ng-container *ngIf="ctrl.get('amount')?.errors?.['required']">
          {{ "financial-information.error_amount_required" | translate }}
        </ng-container>
        <ng-container *ngIf="ctrl.get('amount')?.errors?.['min']">
          {{ errorAmountMinText }}
        </ng-container>
        <ng-container *ngIf="ctrl.get('amount')?.errors?.['max']">
          {{ errorAmountMaxText }}
        </ng-container>
        <ng-container *ngIf="ctrl.get('amount')?.errors?.['pattern']">
          {{ "financial-information.error_amount_pattern" | translate }}
        </ng-container>
      </div>

      <ng-container *ngIf="isRefueling(ctrl.value.label)">
        <ng-container *ngIf="getRefuelFee(i) as feeCtrl">
          <div class="frame-group fee-under-product" [formGroup]="feeCtrl">
            <div class="servicios-parent">
              <span class="product-label-additional">
                {{ feeCtrl.value.label }}
              </span>
              <span
                class="info-icon-wrapper"
                tuiHint="{{
                  'financial-information.tooltip_refuel_fee' | translate
                }}"
                tuiHintDirection="top"
                tuiHintMode="onHover"
              >
                <img
                  [src]="grayInfoIcon"
                  alt="{{
                    'financial-information.tooltip_refuel_fee' | translate
                  }}"
                  class="info-icon"
                />
              </span>
            </div>

            <div class="license-plate1">
              <span *ngIf="!isEditMode">
                {{ feeCtrl.value.amount | number : "1.2-2" }} {{ currency }}
              </span>
              <input
                *ngIf="isEditMode"
                [formControl]="$any(feeCtrl.get('amount'))"
                type="number"
                min="0"
                step="0.01"
                class="price-input"
              />
            </div>
          </div>

          <div
            class="error-msg"
            *ngIf="
              isEditMode &&
              feeCtrl.get('amount')?.invalid &&
              (feeCtrl.get('amount')?.dirty || feeCtrl.get('amount')?.touched)
            "
          >
            <ng-container *ngIf="feeCtrl.get('amount')?.errors?.['required']">
              {{ "financial-information.error_amount_required" | translate }}
            </ng-container>
            <ng-container *ngIf="feeCtrl.get('amount')?.errors?.['min']">
              {{ errorAmountMinText }}
            </ng-container>
            <ng-container *ngIf="feeCtrl.get('amount')?.errors?.['max']">
              {{ errorAmountMaxText }}
            </ng-container>
            <ng-container *ngIf="feeCtrl.get('amount')?.errors?.['pattern']">
              {{ "financial-information.error_amount_pattern" | translate }}
            </ng-container>
          </div>
        </ng-container>
      </ng-container>

      <div class="financial-info-container-child"></div>
    </ng-container>
  </ng-container>

  <!--
    Gastos reportados por los conductores de este servicio. Son informativos: no
    forman parte del precio editable, así que quedan fuera del formulario.
  -->
  <app-expense-summary-list
    [orderHash]="serviceDetail?.orderHash ?? null"
    [currencySymbol]="currency"
  ></app-expense-summary-list>

  <ng-container formArrayName="addCosts">
    <span class="label section-title add-cost-title">
      {{ "financial-information.section_additionalcosts" | translate }}
    </span>

    <div
      *ngFor="let ctrl of addCostsFA.controls; let i = index"
      class="add-cost-item"
      [formGroupName]="i"
    >
      <div class="add-cost-main-row">
        <div class="add-cost-label">
          <img [src]="additionalProduct" alt="" class="add-cost-icon" />
          <span class="product-label-additional">{{ ctrl.value.label }}</span>
        </div>

        <div class="add-cost-value">
          <span *ngIf="!isEditMode" class="amount-readonly">
            {{ ctrl.value.amount | number : "1.2-2" }} {{ currency }}
          </span>

          <ng-container *ngIf="isEditMode">
            <div class="input-trash-row">
              <input
                formControlName="amount"
                type="number"
                min="0"
                max="9999999"
                step="0.01"
                inputmode="decimal"
                class="price-input"
                (keydown)="limitLengthOnKeydown($event, ctrl.get('amount'))"
                [attr.aria-describedby]="'addcost-error-' + i"
                [attr.aria-invalid]="ctrl.get('amount')?.invalid || null"
              />
              <button
                type="button"
                class="btn-delete"
                (click)="removeAdditionalCost(i)"
                [attr.aria-label]="
                  'financial-information.remove_additional_cost' | translate
                "
                title="{{
                  'financial-information.remove_additional_cost' | translate
                }}"
              >
                <img [src]="trashIcon" alt="" />
              </button>
            </div>
          </ng-container>
        </div>
      </div>

      <div
        *ngIf="
          isEditMode &&
          ctrl.get('amount')?.invalid &&
          (ctrl.get('amount')?.dirty || ctrl.get('amount')?.touched)
        "
        class="add-cost-error"
        [attr.id]="'addcost-error-' + i"
        aria-live="polite"
      >
        <span *ngIf="ctrl.get('amount')?.errors?.['required']">
          {{ "financial-information.error_amount_required" | translate }}
        </span>
        <span *ngIf="ctrl.get('amount')?.errors?.['min']">
          {{ errorAmountMinText }}
        </span>
        <span *ngIf="ctrl.get('amount')?.errors?.['max']">
          {{ errorAmountMaxText }}
        </span>
        <span *ngIf="ctrl.get('amount')?.errors?.['pattern']">
          {{ "financial-information.error_amount_pattern" | translate }}
        </span>
      </div>
    </div>
  </ng-container>

  <div class="financial-info-container-inner3">
    <button type="button" class="tui-button1" (click)="addAdditionalCost()">
      <img class="icon" alt="" [src]="plusBlackIcon" />
      <span class="label">
        {{ "financial-information.button_addadditionalcost" | translate }}
      </span>
    </button>
  </div>

  <div>
    <ng-container formArrayName="fees">
      <div class="fee-list">
        <ng-container
          *ngFor="let ctrl of feesFA.controls; let i = index"
          [formGroupName]="i"
        >
          <div
            class="frame-group fee-row fee-row-min-height"
            *ngIf="!isFeeUnderProduct(ctrl)"
          >
            <div class="servicios-parent">
              <span class="license-plate2">{{ ctrl.value.label }}</span>

              <span
                *ngIf="ctrl.value.feeType === FeeTypeEnum.CAFLER_FEE"
                tuiHint="{{
                  'financial-information.tootip_cafler_fee' | translate
                }}"
                tuiHintMode="onHover"
                tuiHintDirection="top"
                class="info-icon-wrapper"
              >
                <img
                  [src]="grayInfoIcon"
                  alt="{{
                    'financial-information.tootip_cafler_fee' | translate
                  }}"
                  class="info-icon"
                />
              </span>
            </div>

            <div class="license-plate1">
              <span *ngIf="!isEditMode">
                {{ ctrl.value.amount | number : "1.2-2" }} {{ currency }}
              </span>
              <input
                *ngIf="isEditMode"
                formControlName="amount"
                type="number"
                min="0"
                step="0.01"
                (keydown)="limitLengthOnKeydown($event, ctrl.get('amount'))"
                class="price-input"
              />
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <div class="frame-parent">
      <div class="frame-wrapper">
        <div class="frame-parent2 fee-row-min-height">
          <div class="license-plate-frame">
            <span class="license-plate2">
              {{ "financial-information.total_taxfree" | translate }}
            </span>
          </div>
          <span class="license-plate1">
            {{ totalTaxFree | number : "1.2-2" }} {{ currency }}
          </span>
        </div>
      </div>

      <div class="frame-wrapper">
        <div class="frame-parent2 fee-row-min-height">
          <div class="license-plate-frame">
            <span class="license-plate12">
              {{ "financial-information.total_vat" | translate }}
              ({{ form.value.taxPercentage }} %)
            </span>
          </div>
          <span class="license-plate1">
            {{ totalTax | number : "1.2-2" }} {{ currency }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="financial-info-container-child"></div>

  <div class="total-amount-row">
    <span class="total-amount-label">
      {{ "financial-information.total_final" | translate }}
    </span>
    <span class="total-amount-label">
      {{ totalWithTax | number : "1.2-2" }} {{ currency }}
    </span>
  </div>
</div>
